define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/xml"
], function(declare, _, xml) {

	return declare(null, {
		_onPublishResponse: function(/*Response*/response) {
			const nodes = response.getNodesOfType("BOMSupplierAttributes") || [];
			const urls = nodes.map(xml.nodeGetURL);
			this.widget.set("responseSupplierAttributes", urls);
			this.inherited(arguments);
		}
	});
});